import { useMemo } from 'react';
import { useUserState } from 'context/UserContext';
import { getFilteredInsurers, getDefaultValues } from 'pages/CarsQuotation/resources';

export const useInsurers = () => {
  const { email } = useUserState();

  const filteredInsurers = useMemo(() => {
    return getFilteredInsurers(email);
  }, [email]);

  const defaultValues = useMemo(() => {
    return getDefaultValues(email);
  }, [email]);

  return {
    filteredInsurers,
    defaultValues,
    userEmail: email,
  };
};
